<div class="wrapper">
	<span class="scenarioNames">{{ scenarioNames() }}</span>

	<div class="room">
		<mat-icon class="secondary" fontSet="fas" fontIcon="fa-door-open" inline />
		<label class="secondary"> {{ T.LABEL_ROOM | translate }}: </label>
		{{ roomName() }}
	</div>

	<mat-chip-set>
		@for (group of groups(); track group.id) {
			<mat-chip [disableRipple]="true">
				<div class="chipContent">
					<mat-icon fontIcon="fa-users" fontSet="fad" inline />
					{{ group.name }}
				</div>
			</mat-chip>
		}
	</mat-chip-set>
</div>
